// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFireDepartmentByIdRequestModel from '../../model/get-fire-department-by-id-request-model';
import GetFireDepartmentByIdRequestDTO from '../dto/get-fire-department-by-id-request-dto';
import dtoSchema from '../schemas/get-fire-department-by-id-request-schema';

export default abstract class GetFireDepartmentByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFireDepartmentByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetFireDepartmentByIdRequestDTO>): GetFireDepartmentByIdRequestModel;
  static toModel(dto: DeepPartial<GetFireDepartmentByIdRequestDTO> | undefined | null): GetFireDepartmentByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFireDepartmentByIdRequestDTO> | undefined | null): GetFireDepartmentByIdRequestModel | undefined {
    return dto ? new GetFireDepartmentByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFireDepartmentByIdRequestModel> | GetFireDepartmentByIdRequestModel): GetFireDepartmentByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetFireDepartmentByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFireDepartmentByIdRequestModel, can not map to GetFireDepartmentByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
